import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import * as React from 'react';
import RollsRoyceContactDropDown from '../../components/RollsRoyceContactDropDown';
import { fetchApi } from '../../services/api';
import { IDNameViewModel } from '../../TypeGen/id-name-view-model';

interface Props {
  quoteId: number;
  authorizationCustomerContacts: IDNameViewModel[];
  onCreated: (data: { OrderID: number, OrderNumber: number, OrderStatus: number }) => void;
}

interface State {
  OrderStatus: number;
  TurnDownReasonID: number;
  Reasons: IDNameViewModel[];
  RevenueType1: number;
  ServiceTeam: number;
  Reference1: string;
  Reference2: string;
  Reference3: string;

  IsRollsRoyceQuote: boolean;

  visible: boolean;
  loading: boolean;
}

export class CreateOrder extends React.Component<Props, State> {

  private revenueAllocation = [
    { value: 0, text: 'Rev. Allocation' },
    { value: 1, text: 'TRUCKLOAD-01' },
    { value: 2, text: 'DEDICATED-03' },
    { value: 3, text: 'EXPEDITE-04' },
    { value: 4, text: 'BROKERAGE-02' },
    { value: 5, text: 'SPECIALIZED-05' },
    //{ value: 6, text: 'TL BROKERAGE-06' },
    { value: 7, text: 'CROSSDOCK/WH-08' },
  ];

  private serviceTeams = [
    { value: 0, text: 'Service Team' },
    { value: 1, text: '1-TRUCKLOAD' },
    { value: 2, text: '2-BROKERAGE' },
    { value: 3, text: '3-DEDICATED' },
    { value: 4, text: '4-EXPEDITE' },
    //{ value: 5, text: '5-TL BROKERAGE' },
    { value: 6, text: '6-SPECIALIZED' },
    //{ value: 7, text: '7-NOT COMMITTED' },
    { value: 8, text: '8-CROSSDOCK/WH' },
    { value: 9, text: '9-AIR REVENUE' }
  ];

  private orderStatus = [
    { value: 100, text: 'Save As: Available' },
    { value: 160, text: 'Save As: Turndown/Turnback' },
    { value: 120, text: 'Save As: Cross Dock Invoice' },
  ];

  constructor(props: Props) {
    super(props);

    this.state = {
      OrderStatus: 100,
      TurnDownReasonID: 0,
      Reasons: [],
      RevenueType1: 0,
      ServiceTeam: 0,
      Reference1: ' ',
      Reference2: ' ',
      Reference3: ' ',

      IsRollsRoyceQuote: false,

      visible: false,
      loading: true,
    };

    this.toggleDialog = this.toggleDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.createOrder = this.createOrder.bind(this);
  }

  toggleDialog(e: any) {
    e.preventDefault();

    this.setState({
      visible: !this.state.visible
    }, () => {
      if (this.state.visible) {
        fetchApi(`/api/Quote/CreateOrder/${this.props.quoteId}`)
          .then((data) => {
            this.setState({
              OrderStatus: data.DefaultOrderStatus,
              TurnDownReasonID: 0,
              Reasons: data.Reasons ?? [],
              RevenueType1: data.DefaultRevenueType1,
              ServiceTeam: data.DefaultServiceTeamID,
              Reference1: data.Reference1,
              Reference2: data.Reference2,
              Reference3: data.Reference3,
              IsRollsRoyceQuote: data.IsRollsRoyceQuote,
              loading: false,
            });
          })
          .catch((e) => {
            this.setState({ visible: false });
            // If not problem details
            if (!e?.status) alert("Unable to load order details!");
          });
      }
    });
  }

  closeDialog() {
    this.setState({ visible: false });
  }

  render() {
    return (
      <>
        <Button themeColor="primary" onClick={this.toggleDialog}>Create Pro</Button>
        {this.state.visible && <Dialog title="Create Pro" onClose={this.closeDialog} className='dialog-w800'>
          <div className="row">
            <div className="col-md-4">
            {this.state.IsRollsRoyceQuote ? <>
              <Label className='mb-0'>Ref 1 / RR Order By Contact</Label>
              <RollsRoyceContactDropDown
                required
                valid={!!this.state.Reference1}
                authorizationCustomerContactName={this.state.Reference1}
                authorizationCustomerContacts={this.props.authorizationCustomerContacts}
                onContactChange={(e) => this.setState({ Reference1: e.customerContactName ?? '' })}
              />
            </> : <Input
                required
                style={{ width: '100%' }}
                label="Reference 1"
                value={this.state.Reference1}
                onChange={(e) => this.setState({ Reference1: e.target.value.toString() })}
              />}
            </div>

            <div className="col-md-4">
              <Input
                required
                style={{ width: '100%' }}
                label="Reference 2 / Thread"
                value={this.state.Reference2}
                onChange={(e) => this.setState({ Reference2: e.target.value.toString() })}
              />
            </div>

            <div className="col-md-4">
              <Input
                required
                style={{ width: '100%' }}
                label="Reference 3 / Station"
                value={this.state.Reference3}
                onChange={(e) => this.setState({ Reference3: e.target.value.toString() })}
              />
            </div>
          </div>

          <br />

          <DropDownList
            required
            valid={this.state.RevenueType1 > 0}
            style={{ width: '100%' }}
            value={this.revenueAllocation.find(x => x.value == this.state.RevenueType1)}
            data={this.revenueAllocation}
            onChange={(e) => this.setState({ RevenueType1: e.target.value.value })}
            textField="text"
          />
          <br /><br />
          <DropDownList
            required
            valid={this.state.ServiceTeam > 0}
            style={{ width: '100%' }}
            value={this.serviceTeams.find(x => x.value == this.state.ServiceTeam)}
            data={this.serviceTeams}
            onChange={(e) => this.setState({ ServiceTeam: e.target.value.value })}
            textField="text"
          />
          {/*<br /><br />
          <DropDownList
            style={{ width: '100%' }}
            value={this.orderStatus.find(x => x.value == this.state.OrderStatus)}
            data={this.orderStatus}
            onChange={(e) => this.setState({ OrderStatus: e.target.value.value, TurnDownReasonID: 0 })}
            textField="text"
          />*/}
          {this.state.OrderStatus === 160 && <>
            <br /><br />
            <DropDownList
              required
              valid={this.state.TurnDownReasonID > 0}
              style={{ width: '100%' }}
              value={this.state.Reasons.find(x => x.ID === this.state.TurnDownReasonID)}
              data={this.state.Reasons}
              defaultValue={{ ID: 0, Name: 'Select Turndown/Turnback Reason' }}
              dataItemKey="ID"
              textField="Name"
              onChange={(e) => this.setState({ TurnDownReasonID: e.target.value.ID })}
            />
          </>}
          <DialogActionsBar>
            <Button themeColor="primary" disabled={this.state.loading} onClick={this.createOrder}>Create Pro</Button>
          </DialogActionsBar>
        </Dialog>}
      </>
    );
  }

  private createOrder(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();

    this.setState({ loading: true });

    const data = {
      QuoteID: this.props.quoteId,
      OrderStatus: this.state.OrderStatus,
      TurnDownReasonID: this.state.OrderStatus === 160 ? this.state.TurnDownReasonID : null,
      ServiceTeam: this.state.ServiceTeam,
      RevenueType1: this.state.RevenueType1,
      Reference1: this.state.Reference1,
      Reference2: this.state.Reference2,
      Reference3: this.state.Reference3,
    }
    fetchApi('/api/Quote/CreateOrder', data, 'POST')
      .then((response: { OrderID: number, OrderNumber: number, ErrorMessage: string }) => {
        if (response.ErrorMessage) {
          alert(response.ErrorMessage);
        } else {
          this.setState({ visible: false });
          this.props.onCreated({ OrderID: response.OrderID, OrderNumber: response.OrderNumber, OrderStatus: this.state.OrderStatus });
        }
      })
      .catch((e) => {
        // If not problem details
        if (!e?.status) alert("Unable to create order!")
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
}
